import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';

const model = {
  state: {
    detailData: {
      skuList: [],
    },
    cityCodes: [],
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { tsOrder }, getState }: any) => ({
    async getDetailData(params: any) {
      const data = await fetch('/saasmerchant/web/tsOrder/orderDetail', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        tsOrder.setState({ detailData: data });
      }
    },
    resetDetailData() {
      tsOrder.setState({ detailData: { skuList: [] } });
    },
    // 堂食订单批量导出
    async tsExportOrder({ ...expTsData }) {
      const formParams = filterNull({
        ...expTsData,
      });
      const data = await fetch('/saasmerchant/web/tsOrder/queryListByEs', {
        type: 'POST',
        useJson: true,
        params: {
          ...formParams,
          export: 1,
          // RD需要page和pageSize两个入参
          page: 1,
          pageSize: 10,
        },
      });
      return data;
    },
    async getBDList(params) {
      const bdList = await fetch(
        '/saasmerchant/fsarea/businessDistrict/getBusinessDistrictIdByNameAndPermission',
        {
          params,
        },
      );
      tsOrder.setState({ bdList: bdList || [] });
      return bdList;
    },
    async getCityList(params) {
      const data = await fetch('/saasmerchant/web/auth/areaModuleWithPermission', {
        params,
      });

      tsOrder.setState({ cityOptions: data || [] });
      return data;
    },
  }),
};

export default model;
